module.exports = __webpack_public_path__ + "static/mob-frame-tala-6991a3811c6639f32929551733abf71d.png";